import { render, staticRenderFns } from "./PersonActions.vue?vue&type=template&id=08bf3d8a"
import script from "./PersonActions.vue?vue&type=script&lang=js"
export * from "./PersonActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports